import logo from "../../assets/images/logo/logo.png";

const Footer = () => {
  return (
    <section className="footer section-spacing-24 no-padding-bottom flexi-dark-bg">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <ul className="footer-items-container">
              <li className="footer-item footer-about-item">
                <div className="footer-about">
                  <img src={logo} alt="Flexi Painters logo" />
                  <p>
                    Flexi Painters is a Kampala-based professional painting
                    company setting higher standards for professional painting
                    services across Uganda.
                  </p>
                </div>
              </li>
              <li className="footer-item">
                <h3>Useful Links</h3>
                <ul className="footer-menu">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>
                    <a href="/portfolio">Portfolio</a>
                  </li>
                  <li>
                    <a href="/case-studies">Case Studies</a>
                  </li>
                  <li>
                    <a
                      href="https://form.jotform.com/flexipainters/book-site-visit"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Book Site Visit
                    </a>
                  </li>
                </ul>
              </li>
              <li className="footer-item">
                <h3>Company</h3>
                <ul className="footer-menu">
                  <li>
                    <a href="/about">About</a>
                  </li>
                  <li>
                    <a href="/services">Services</a>
                  </li>
                  <li>
                    <a href="/contact">Contact Us</a>
                  </li>
                  <li>
                    <a href="/privacy-policy">Privacy Policy</a>
                  </li>
                </ul>
              </li>
              <li className="footer-item">
                <h3>Social Media</h3>
                <ul className="footer-menu">
                  <li>
                    <a
                      href="https://tiktok.com/flexipainters"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Tiktok
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://youtube.com/flexipainters"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Youtube
                    </a>
                  </li>
                  <li className="hide-desktop">
                    <a
                      href="https://x.com/flexipainters"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      X/Twitter
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://facebook.com/flexipainters"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Facebook
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://instagram.com/flexipainters"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Instagram
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
            <div className="footer-copyright-strip ntuna-dark-secondary center padding-24">
              <p>
                &copy; 2020 - {new Date().getFullYear()} FLEXIBLE PAINTERS WORLD
                & SERVICES LTD, All Rights Reserved
              </p>
              <p className="uppercase">
                Website by{" "}
                <a
                  href="https://ntuna.com"
                  className="flexi-magenta"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  NTUNA.COM
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
